import { ConstData } from "./helpers"

export const ENQUIRY_STATUSES: ConstData[] = [
  { title: "Received", value: 0 },
  { title: "Follow up", value: 1 },
  { title: "Pending DDR", value: 2 },
  { title: "Unreachable", value: 3 },
  { title: "Declined", value: 4 },
  { title: "Duplicate", value: 5 },
  { title: "Enrolled", value: 6 },
  { title: "Invalid", value: 7 },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/enquiries.ts